export const MODAL_STYLES = 'styles';
export const MODAL_LOGIC = 'logic';
export const MODAL_LIBRARY = 'library';
